<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">系统设置</div>
      <el-form-item label="系统名称" :rules="[{required: true,message: ' '}]" prop="name">
        <el-input v-model="form.name" placeholder="系统名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="系统描述"  prop="describe">
        <el-input v-model="form.describe" placeholder="系统描述"  type="textarea" :rows="3" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="联系方式"  prop="phone">
        <el-input v-model="form.phone" placeholder="联系方式" type="number"   class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="系统LOGO" prop="describe">
        <div v-if="form.logo.file_path" class="default-image-box" @click="isAboutLogoUpload = true">
          <div class="image-box">
            <img :src="form.logo.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteshareLogoImg">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutLogoUpload = true"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

       <el-form-item label="1元等于多少金币" :rules="[{required: true,message: '请输入兑换比例'}]" prop="coin_rate">
    <el-input v-model="form.coin_rate" placeholder="例如：100" class="max-w460">
      <template slot="append">金币</template>
    </el-input>
    <div class="tips">设置1元人民币可兑换的金币数量</div>
  </el-form-item>

      <el-form-item label="默认分享图" prop="describe">
        <div v-if="form.sharelogo.file_path" class="default-image-box" @click="isAboutshareLogoUpload = true">
          <div class="image-box">
            <img :src="form.sharelogo.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteshareLogoImg">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutshareLogoUpload = true"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

      <el-form-item label="关于banner" prop="describe">
        <div v-if="form.about_banner.file_path" class="default-image-box" @click="isAboutBannerUpload = true">
          <div class="image-box">
            <img :src="form.about_banner.file_path" alt="product_default_image">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg">
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="isAboutBannerUpload = true"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>

      <div class="common-form">物流查询api</div>
      <el-form-item label="应用帐号" :rules="[{required: false,message: ' '}]" prop="customer">
        <el-input v-model="form.kuaidi100.customer" placeholder="" class="max-w460"></el-input>
        <div v-if="!w7" class="tips">用于查询物流信息,<el-link :underline="false" href="http://pm.y01.cn/v2/pm/login/" target="_blank"
            type="primary">物流查询接口免费申请</el-link>
        </div>
        <div v-else class="tips">请联系管理员
        </div>
      </el-form-item>
      <el-form-item label="应用秘钥" :rules="[{required: false,message: ' '}]" prop="key">
        <el-input v-model="form.kuaidi100.key" placeholder="" class="max-w460"></el-input>
      </el-form-item>

      <!-- 公告记录部分 -->
      <div class="common-form">公告设置</div>
      <el-form-item label="首页公告图标：">
        <div class="diy-notice-icon">
          <img v-img-url="form.notice.icon" alt="" @click="onEditorSelectImage(form.notice, 'icon')">
        </div>
        <div>建议尺寸32×32</div>
      </el-form-item>
      
      <el-form-item label="首页公告跳转链接">
        <div class="d-s-c">
          <div class="url-box flex-1">
            <span class="key-name">链接名称：</span>
            <el-input :value="form.notice.linkName + form.notice.linkUrl"></el-input>
          </div>
          <div class="url-box ml10">
            <el-button type="primary" @click="changeLink">选择链接</el-button>
          </div>
        </div>
      </el-form-item>
      
      <el-form-item label="首页公告记录">
        <el-button size="small" type="primary" @click="addOrder">新增公告</el-button>
     
        <el-table :data="form.notice.order" border size="mini" style="width: 100%;margin-top: 20px;">
   

          <el-table-column prop="name" label="公告记录">
            <template v-slot="scope">
              <div>
                <div class="d-s-c">
                  <el-input style="width: 650px;" type="textarea" v-model="scope.row.context" placeholder="请输入公告记录"></el-input>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="操作" width="100">
            <template v-slot="scope">
              <div style="color: blue;" @click="delOrder(scope.$index)">删除</div>
            </template>
          </el-table-column>
        </el-table>

      </el-form-item>


           <el-form-item label="惠购公告跳转链接">
        <div class="d-s-c">
          <div class="url-box flex-1">
            <span class="key-name">链接名称：</span>
            <el-input :value="form.hgnotice.linkName + form.hgnotice.linkUrl"></el-input>
          </div>
          <div class="url-box ml10">
            <el-button type="primary" @click="changeLinkhg">选择链接</el-button>
          </div>
        </div>
      </el-form-item>
      
      <el-form-item label="惠购公告记录">
        <el-button size="small" type="primary" @click="addhgOrder">新增公告</el-button>
     
        <el-table :data="form.hgnotice.order" border size="mini" style="width: 100%;margin-top: 20px;">
   

          <el-table-column prop="name" label="惠购公告记录">
            <template v-slot="scope">
              <div>
                <div class="d-s-c">
                  <el-input style="width: 650px;" type="textarea" v-model="scope.row.context" placeholder="请输入公告记录"></el-input>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="操作" width="100">
            <template v-slot="scope">
              <div style="color: blue;" @click="delhgOrder(scope.$index)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <div style="height: 100px;"></div>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--商品图片组件-->
     <Upload
      v-if="isupload"
      :isupload="isupload"
      :config="{ total: 3 }"
      @returnImgs="returnImgsFunc"
    ></Upload>

    <Upload v-if="isAboutBannerUpload" :config="{ total: 9 }" :isupload="isAboutBannerUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    <!-- logo图片组件 -->
    <Upload v-if="isAboutLogoUpload" :config="{ total: 9 }" :isupload="isAboutLogoUpload" @returnImgs="returnLogoImgsFunc">上传图片</Upload>
    <Upload v-if="isAboutshareLogoUpload" :config="{ total: 1 }" :isupload="isAboutshareLogoUpload"
       @returnImgs="returnshareLogoImgsFunc">上传图片</Upload>

    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset"></Setlink>  
    <Setlink v-if="is_linksethg" :is_linkset="is_linksethg" @closeDialog="closeLinksethg"></Setlink>  
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import _ from 'lodash'
import Upload from "@/components/file/Upload"
import Setlink from '@/components/setlink/Setlink';

export default {
  components: {
    Upload,
    Setlink
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
       isupload: false,
      isAboutBannerUpload: false,
      isAboutLogoUpload: false,
      isAboutshareLogoUpload: false,
      is_linkset: false,
      is_linksethg:false,
       imgModel: null,
      
      /*form表单数据*/
      form: {
        name: '',
        describe: '',
        phone: "",
         coin_rate: 100,
        about_banner: {
          file_id: '',
          file_path: ''
        },
        logo: {
          file_id: '',
          file_path: ''
        },
        sharelogo: {
          file_id: '',
          file_path: ''
        },
        msg: '',
        kuaidi100: {
          customer: '',
          key: '',
        },
        checkedCities: [],
        is_open_cart: true,
        notice: {
          icon: '',
          linkName: '',
          linkUrl: '',
          order: []
        },
         hgnotice: {
          icon: '',
          linkName: '',
          linkUrl: '',
          order: []
        },

      },
      w7: {},
      all_type: [],
      type: [],
    }
  },
  created() {
    this.getParams()
  },


  methods: {
    /*获取配置数据*/
    getParams() {
  let self = this
  SettingApi.storeDetail({}, true).then(res => {
    if (res.code) {
      self.form.checkedCities = res.data.vars.values.delivery_type
      let vars = res.data.vars.values
      self.form = _.merge({}, self.form, res.data.vars.values);

      // 确保notice.order是一个数组
      console.log(Array.isArray(self.form.notice.order)); // true
      
      if (!self.form.notice) {
        self.form.notice = {
          icon: '',
          linkName: '',
          linkUrl: '',
          order: []
        }
      } 

      self.type = vars.delivery_type
      self.all_type = res.data.all_type
      self.w7 = res.data.w7
       self.$nextTick(() => {
        self.$forceUpdate();
      });
      self.loading = false
    } else {
      self.$message.error('错了哦，这是一条错误消息')
    }
  }).catch(error => {
    console.log(error)
  })
},

    /*提交*/
    onSubmit() {
      let self = this
      let params = this.form
      if (params.checkedCities.length < 1) {
        self.$message({
          message: '配送方式至少选择一种！',
          type: 'warning',
        })
        return
      }
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你，系统设置成功',
                type: 'success',
              })
              self.$router.push('/setting/store/index')
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    
    /*公告相关方法*/
    changeLink() {
      this.is_linkset = true;
    },  
       changeLinkhg() {
      this.is_linksethg = true;
    }, 

        returnImgsFunc(e) {
      if (e != null) {
        this.imgModel.index[this.imgModel.imgUrl] = e[0]["file_path"];
      }
      console.log(11111,this.imgModel.index)
      this.isupload = false;
    },
    
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.form.notice.linkUrl = e.url;
        this.form.notice.linkName = "链接到" + " " + e.type + " " + e.name;
      }
    },

       closeLinksethg(e) {
      this.is_linksethg = false;
      if (e) {
        this.form.hgnotice.linkUrl = e.url;
        this.form.hgnotice.linkName = "链接到" + " " + e.type + " " + e.name;
      }
    },
    
    delOrder(index) {
      this.form.notice.order.splice(index, 1)
    },
     delhgOrder(index) {
      this.form.hgnotice.order.splice(index, 1)
    },
    
    addOrder() {
      this.form.notice.order.push({
        "code": this.randomString(8, this.randomString(6, 0)),
        "sort": 50,
        "context": "",
      });
    },
       addhgOrder() {
      this.form.hgnotice.order.push({
        "code": this.randomString(8, this.randomString(6, 0)),
        "sort": 50,
        "context": "",
      });
    },
    
    randomString(len, chars) {
      len = len || 32;
      chars = chars || 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      var pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    
    onEditorSelectImage(index, imgUrl) {
        this.isupload = true;
      this.imgModel = {
        index: index,
        imgUrl: imgUrl,
      };
      console.log('Image selection triggered',index, imgUrl);
    },
    
    /*图片上传相关方法*/
    deleteImg() {
      this.form.about_banner = {
        file_id: '',
        file_path: ''
      }
    },
    
    deleteLogoImg() {
      this.form.logo = {
        file_id: '',
        file_path: ''
      }
    },
    
    deleteshareLogoImg() {
      this.form.sharelogo = {
        file_id: '',
        file_path: ''
      }
    },
    
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.about_banner.file_id = e[0].file_id
        this.form.about_banner.file_path = e[0].file_path
      }
      this.isAboutBannerUpload = false
    },
    
    returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.logo.file_id = e[0].file_id
        this.form.logo.file_path = e[0].file_path
      }
      this.isAboutLogoUpload = false
    },
    
    returnshareLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.sharelogo.file_id = e[0].file_id
        this.form.sharelogo.file_path = e[0].file_path
      }
      this.isAboutshareLogoUpload = false
    },
  }
}
</script>

<style scoped lang="scss">
.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.diy-notice-icon, .diy-notice-icon img {
  width: 32px;
  height: 32px;
}

.d-s-c {
  display: flex;
  align-items: center;
}

.url-box {
  display: flex;
  align-items: center;
  
  .key-name {
    white-space: nowrap;
  }
}

.ml10 {
  margin-left: 10px;
}

.flex-1 {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/store/index.vue